export default function merge(target, source) {
	var target = _.cloneDeep(target);
	var source = _.cloneDeep(source);//JSON.parse(JSON.stringify(target));
	var r = target;

	for (var key in source) {
		//console.log(source[key], typeof source[key] === 'object' ? 'is object' : 'is NOT object');
		//console.log(source[key], Array.isArray(source[key]) ? 'is array' : 'is NOT array');
		//target[key] = Array.isArray(source[key]) ? Array.from(source[key]) : (source[key] !== null && typeof source[key] === 'object' ? merge(target.hasOwnProperty(key) ? target[key] : {}, source[key]) : source[key]);

		if (Array.isArray(source[key])) {
			// Might not be required after deep clone
			r[key] = Array.from(source[key]);
		} else if (source[key] !== null && typeof source[key] === 'object') {
			r[key] = merge(target.hasOwnProperty(key) && target[key] !== null ? target[key] : {}, source[key]);
		} else {
			r[key] = source[key];
		}
	}

	return r;

	

	// Add functions
	Object.keys(target).forEach(function (key) {
		if (typeof target[key] === 'function') {
			r[key] = target[key];
		}
	});

	for (var key in source) {
		//console.log(source[key], typeof source[key] === 'object' ? 'is object' : 'is NOT object');
		//console.log(source[key], Array.isArray(source[key]) ? 'is array' : 'is NOT array');
		r[key] = Array.isArray(source[key]) ? Array.from(source[key]) : (source[key] !== null && typeof source[key] === 'object' ? merge(r.hasOwnProperty(key) ? r[key] : {}, source[key]) : source[key]);
	}

    return r;
}